import { useEffect, useRef } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Conexión WebSocket de la comunidad con reconexión automática. */
export const useCommunitySocket = (onEvent) => {
  const handler = useRef(onEvent);
  handler.current = onEvent;

  useEffect(() => {
    let ws;
    let retry;
    let closed = false;

    const connect = () => {
      const url = `${BACKEND.replace(/^http/, "ws")}/api/community/ws`;
      ws = new WebSocket(url);
      ws.onmessage = (e) => {
        try {
          handler.current?.(JSON.parse(e.data));
        } catch (err) {
          console.warn("Evento de comunidad no válido:", err, e.data);
        }
      };
      ws.onclose = () => { if (!closed) retry = setTimeout(connect, 2500); };
      ws.onerror = (err) => {
        console.warn("WebSocket de la comunidad con error, reintentando:", err);
        try { ws.close(); } catch (closeErr) { console.warn("No se pudo cerrar el socket:", closeErr); }
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      try { ws?.close(); } catch (err) { console.warn("No se pudo cerrar el socket:", err); }
    };
  }, []);
};

export default useCommunitySocket;
